export default __webpack_public_path__ + "static/media/2427.7a21b92d.png";